import { Sheet, SheetContent, SheetTrigger, SheetTitle, SheetDescription } from '@/components/ui/sheet'
import { Button } from '@/components/ui/button'
import { Menu } from 'lucide-react'
import { DashboardNav } from './DashboardNav'
import { ScrollArea } from '../ui/scroll-area'

interface MobileNavProps {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
}

export function MobileNav({ isOpen, onOpenChange }: MobileNavProps) {
  return (
    <Sheet open={isOpen} onOpenChange={onOpenChange}>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" className="md:hidden">
          <Menu className="h-6 w-6" />
          <span className="sr-only">Toggle menu</span>
        </Button>
      </SheetTrigger>
      <SheetContent side="left" className="w-72 p-0">
        <ScrollArea className="h-full py-6">
          <div className="px-2 py-2">
            <SheetTitle className="mb-2 px-4 text-lg font-semibold tracking-tight">
              Navigation
            </SheetTitle>
            <SheetDescription className="sr-only">
              Mobile navigation menu
            </SheetDescription>
            <DashboardNav onNavClick={() => onOpenChange(false)} />
          </div>
        </ScrollArea>
      </SheetContent>
    </Sheet>
  )
}